module.exports = __webpack_public_path__ + "static/media/thumbnail.f5e6645b.jpg";